import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { update } from "lodash";
import { jwtDecode } from "jwt-decode";
import { IoCloseOutline } from "react-icons/io5";
import moment from "moment";

import { showToast } from "../utils/toastUtils";
import {
  getClinicIdFromToken,
  getToken,
  getValueFromToken,
} from "../utils/tokenUtils";
import { serviceFetchDoctorList } from "../services/api";
import {
  serviceCopyClinicService,
  serviceGetServiceDetailForClinic,
  serviceUpdateClinicService,
} from "../services/profileApi";
import InputComponent from "./InputComponent";
import CustomSelect from "./CustomSelect";
import { Formik, Field, Form, ErrorMessage, useFormik } from "formik";
import * as Yup from "yup";
import { serviceValidation } from "../utils/validations/serviceValidation";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CustomInput, localDate } from "../utils/commonUtils";

const AddServicePage = ({ ShowServiceItem, onClose, fetchClinicId }) => {
  const navigate = useNavigate();
  const [serviceItemIdProps, setServiceItemIdProps] = useState(
    ShowServiceItem?.service_item_id
  );
  const [name, setName] = useState(ShowServiceItem?.name);
  const [doctorId, setDoctorId] = useState(ShowServiceItem?.doctor_id);
  const [clinicId, setClinicId] = useState(ShowServiceItem?.clinic_id);
  const [price, setPrice] = useState(ShowServiceItem?.default_price);
  const [description, setDescription] = useState(ShowServiceItem?.description);
  const [code, setCode] = useState(ShowServiceItem?.code);
  const [startdate, setStartDate] = useState(
    ShowServiceItem?.start_date?.split("T")[0]
  );
  const [enddate, setEndDate] = useState(
    ShowServiceItem?.end_date?.split("T")[0]
  );

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [serviceItemId, setServiceItemId] = useState(null);
  const [decodedClinicId, setDecodedClinicId] = useState(null);
  const [localSelectedDoctor, setLocalSelectedDoctor] = useState(doctorId);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [DoctorsForModal, setDoctorsForModal] = useState("");
  const [doctors, setDoctors] = useState([]);

  const fecthUserData = async (serviceItemIdProps) => {
    try {
      const token = localStorage.getItem("token");
      const decodedToken = jwtDecode(token);
      setDecodedClinicId(decodedToken.clinic_ids[0]); // Save decoded clinic_id
      if (serviceItemIdProps) {
        const response = await serviceGetServiceDetailForClinic(
          serviceItemIdProps
        );
        const data = response.data;
      }
    } catch (error) {
      console.error("Error deleting item:", error);
      setError("Failed to delete item. Please try again later.");
    }
  };

  const fetchDoctors = async () => {
    const userId = getValueFromToken("user_id");

    try {
      const doctorsData = await serviceFetchDoctorList(userId);

      if (
        doctorsData &&
        doctorsData?.data?.doctors &&
        doctorsData?.data?.doctors?.length > 0
      ) {
        const allDoctorsOption = {
          doctor_id: "all",
          first_name: "All Doctors",
          last_name: "",
        };

        setDoctors(doctorsData.data.doctors);
        setDoctorsForModal(doctorsData.data.doctors);

        // Optionally set the selectedDoctor to the first doctor or any other default value
        setSelectedDoctor(doctorsData.data.doctors[0].doctor_id);
      } else {
        //navigate("/clinic/doctor?addDoctor=true");
      }
    } catch (error) {
      console.error("Error fetching doctors:", error);
      // Handle error or set a state to display an error message
    }
  };

  useEffect(() => {
    fecthUserData(serviceItemIdProps);
  }, []);

  useEffect(() => {
    fetchDoctors();
  }, [navigate]);

  const doctorIdToName = {};
  doctors.forEach((doctor) => {
    doctorIdToName[
      doctor.doctor_id
    ] = `${doctor.first_name} ${doctor.last_name}`;
  });

  const handleCloseButtonClick = () => {
    // Perform the action to exit the page
    onClose();
  };

  const handleSubmitFormik = useFormik({
    initialValues: {
      name: ShowServiceItem?.name || "",
      doctorId: ShowServiceItem?.doctor_id || "",
      code: ShowServiceItem?.code || "",
      description: ShowServiceItem?.description || "",
      price: ShowServiceItem?.default_price || "",
      startdate: ShowServiceItem?.start_date?.split("T")[0] || "",
      enddate: ShowServiceItem?.end_date?.split("T")[0] || "",
    },
    validationSchema: serviceValidation,
    validateOnChange: false,
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        const formData = {
          service_item_id: ShowServiceItem?.service_item_id || "",
          name: values.name,
          doctorId: values.doctorId,
          clinicId: getClinicIdFromToken() || "",
          price: values.price,
          description: values.description,
          code: values.code,
          start_date: values.startdate,
          end_date: values.enddate,
        };

        if (formData.service_item_id) {
          const response = await serviceUpdateClinicService(formData);
          if (response?.status) {
            showToast(response.message, "success");
          } else {
            showToast(response?.message?.msg, "error");
          }
        } else {
          const response = await serviceCopyClinicService(formData);
          if (response?.status) {
            showToast(response.message, "success");
          } else {
            showToast(response?.message?.msg, "error");
          }
        }
        fetchClinicId();
        onClose();
      } catch (error) {
        setError(error.message.data);
        showToast(error.message, "error");
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 overflow-y-auto h-full w-full z-50 flex justify-center items-center pt-10">
      <div className="relative bg-white rounded-lg shadow-xl mx-4 md:mx-0 w-full max-w-2xl p-5 px-10">
        <div className=" mb-5 flex justify-between border-b pb-3  ">
          <span className="text-xl font-semibold text-gray-800 mt-3">
            {serviceItemIdProps ? "Update Service" : "Add Service"}
          </span>
          <button
            onClick={handleCloseButtonClick}
            className=" absolute right-3 top-3 text-gray-600 bg-gray-100 hover:bg-gray-300 focus:ring-4 focus:outline-none focus:ring-gray-200  hover:text-gray-800 px-0 w-10 h-10 inline-flex justify-center items-center rounded-full text-2xl m-1.5"
          >
            <IoCloseOutline />
          </button>
        </div>

        <Formik
          initialValues={handleSubmitFormik.initialValues}
          validationSchema={handleSubmitFormik.validationSchema}
          onSubmit={handleSubmitFormik.handleSubmit}
        >
          {({ errors, touched }) => (
            <Form className=" grid grid-cols-2 gap-x-5  gap-y-3  p-6 px-0">
              <InputComponent
                label="Name"
                id="name"
                value={handleSubmitFormik.values.name}
                onChange={handleSubmitFormik.handleChange}
                type="text"
                className="w-full"
                error={handleSubmitFormik.errors.name}
              />

              <div className="w-full">
                <label
                  for="role"
                  class="mb-1 text-gray-800 bg-white font-semibold text-[14px] block"
                >
                  Doctor
                </label>
                <CustomSelect
                  htmlFor="doctorId"
                  value={handleSubmitFormik.values.doctorId}
                  isSearchable={false}
                  isClearable={false}
                  isDisabled={serviceItemIdProps}
                  className={" w-full form_select"}
                  onChange={(option) => {
                    handleSubmitFormik.handleChange({
                      target: {
                        name: "doctorId",
                        value: option.value,
                      },
                    });
                  }}
                  options={[
                    { value: "", label: "Select Doctor" },
                    { value: "-1", label: "All Doctors" },
                    ...doctors.map((doctor) => ({
                      value: doctor.doctor_id,
                      label: `${doctor.first_name} ${doctor.last_name}`,
                    })),
                  ]}
                />
                <div className=" text-red-500 text-sm text-left">
                  {handleSubmitFormik.errors.doctorId}
                </div>
              </div>

              <InputComponent
                label="Code"
                id="code"
                value={handleSubmitFormik.values.code}
                onChange={handleSubmitFormik.handleChange}
                type="text"
                className="w-full"
                error={handleSubmitFormik.errors.code}
              />
              <InputComponent
                label="Description"
                id="description"
                value={handleSubmitFormik.values.description}
                onChange={handleSubmitFormik.handleChange}
                type="text"
                className="w-full"
                error={handleSubmitFormik.errors.description}
              />
              <InputComponent
                label="Price"
                id="price"
                value={handleSubmitFormik.values.price}
                onChange={handleSubmitFormik.handleChange}
                type="number"
                className="w-full"
                error={handleSubmitFormik.errors.price}
              />

              <div>
                <label
                  for="startdate"
                  class="mb-1 text-gray-800 bg-white font-semibold text-[14px] block"
                >
                  Start Date:
                </label>
                <ReactDatePicker
                  wrapperClassName="w-full"
                  showYearDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={100}
                  selected={startdate ? localDate(new Date(startdate)) : null}
                  onChange={(date) => {
                    const adjustedDate = date ? localDate(date) : null;
                    setStartDate(adjustedDate);
                    handleSubmitFormik.handleChange({
                      target: {
                        name: "startdate",
                        value: adjustedDate,
                      },
                    });
                  }}
                  dateFormat="dd/MM/yyyy"
                  customInput={<CustomInput />}
                  maxDate={enddate ? new Date(enddate) : null}
                />
                <div className=" text-red-500 text-sm text-left">
                  {handleSubmitFormik.errors.startdate}
                </div>
              </div>

              <div>
                <label
                  for="endstart"
                  class="mb-1 text-gray-800 bg-white font-semibold text-[14px] block"
                >
                  End Date:
                </label>
                <ReactDatePicker
                  wrapperClassName="w-full"
                  showYearDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={100}
                  selected={enddate ? localDate(new Date(enddate)) : null}
                  onChange={(date) => {
                    const adjustedDate = date ? localDate(date) : null;
                    setEndDate(adjustedDate);
                    handleSubmitFormik.handleChange({
                      target: {
                        name: "enddate",
                        value: adjustedDate,
                      },
                    });
                  }}
                  dateFormat="dd/MM/yyyy"
                  customInput={<CustomInput />}
                  minDate={startdate ? new Date(startdate) : null}
                />
                <div className=" text-red-500 text-sm text-left">
                  {handleSubmitFormik.errors.enddate}
                </div>
              </div>

              <div className=" col-span-2">
                <button
                  type="submit"
                  className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                  disabled={isLoading}
                  // onClick={handleSubmitFormik.handleSubmit}
                >
                  {isLoading
                    ? "Loading..."
                    : serviceItemIdProps
                    ? "Update"
                    : "Create"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddServicePage;
